import type { FC } from 'react'

import type { TIconProps } from 'types'

const ArrowTop: FC<TIconProps> = ({ className }) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.36321 15.1368C6.71469 15.4883 7.28453 15.4883 7.63601 15.1368L11.9996 10.7732L16.3632 15.1368C16.7147 15.4883 17.2845 15.4883 17.636 15.1368C17.9875 14.7853 17.9875 14.2155 17.636 13.864L12.636 8.86399C12.2845 8.51252 11.7147 8.51252 11.3632 8.86399L6.36321 13.864C6.01174 14.2155 6.01174 14.7853 6.36321 15.1368Z'
      fill='#19191A'
    />
  </svg>
)

export default ArrowTop
